import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Axios instance for session-based auth
const sessionAPI = axios.create({
  baseURL: `${API_BASE_URL}/session`,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Add request interceptor to support tab-specific impersonation
sessionAPI.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('impersonation_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Minimal interceptors for unified error handling
sessionAPI.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

const sessionService = {
  login: async ({ email, password }) => {
    const { data } = await sessionAPI.post('/login', { email, password });
    return data; // { success, user }
  },
  logout: async () => {
    const { data } = await sessionAPI.post('/logout');
    return data; // { success }
  },
  // Logged-out visitors get { success: true, user: null } instead of a 401.
  me: async () => {
    const { data } = await sessionAPI.get('/me', { params: { optional: 1 } });
    return data; // { success, user }
  },
};

export default sessionService;
